module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/icons/delta-9775ef06f1c23bfa3ca655ddf14ec51b.png";